import { Stack } from "@altimateai/lego";
import { Tooltip as UITooltip } from "@altimateai/lego";
import classNames from "classnames";
import styles from "@/pages/query/styles.module.scss";
import { InfoIcon } from "@assets/icons";

export const ExecutionStatus = (props: {
  execution_status: string; // "SUCCESS" | "FAIL"
  success_label?: string;
  fail_label?: string;
  error_message?: string;
}) => {
  return props.execution_status === "SUCCESS" ? (
    <div className={classNames("text-success text-center", styles.success)}>
      {props.success_label || props.execution_status}
    </div>
  ) : (
    <UITooltip title={props.error_message}>
      <Stack align="center" justify="center" className={classNames("text-danger", styles.fail)}>
        <div>{props.fail_label || props.execution_status}</div>
        {props.error_message && (
          <Stack align="center">
            <InfoIcon />
          </Stack>
        )}
      </Stack>
    </UITooltip>
  );
};

export const ExecutionStatusCount = (props: { success_count: number; run_count: number }) => (
  <Stack direction="column" className="gap-xs">
    {props.success_count > 0 && (
      <ExecutionStatus
        execution_status="SUCCESS"
        success_label={`${props.success_count} success`}
      />
    )}
    {props.run_count - props.success_count > 0 && (
      <ExecutionStatus
        execution_status="FAIL"
        fail_label={`${props.run_count - props.success_count} fail`}
      />
    )}
  </Stack>
);
